import { render } from "./PostVote.vue?vue&type=template&id=3ea32aac"
import script from "./PostVote.vue?vue&type=script&lang=js"
export * from "./PostVote.vue?vue&type=script&lang=js"

import "./PostVote.vue?vue&type=style&index=0&id=3ea32aac&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__